<script context="module" lang="ts">
  type Attrs = {
    src: string;
    alt: string;
    align: Alignment;
    uuid: string;
    type: string;
    fileName: string;
    fileSize: number;
  };
</script>

<script lang="ts">
  import OVIcon from "$components/+blocks/OVIcon/OVIcon.svelte";
  import { Alignment, CSS_ALIGNMENT } from "$components/editor/extensions/blocks/shared/attributes";
  import { NodeViewWrapper } from "svelte-tiptap";
  import type { NodeViewProps } from "@tiptap/core";
  import GutterMenu from "$components/editor/extensions/+shared/GutterMenu.svelte";
  import { getSizeHuman } from "$components/editor/utils";
  import IconButton from "$components/+blocks/IconButton/IconButton.svelte";
  import { Attachment, Download, Rive } from "$components/+blocks/OVIcon";

  export let node: NodeViewProps["node"];
  export let editor: NodeViewProps["editor"];
  export let deleteNode: NodeViewProps["deleteNode"];
  export let isEditable: boolean;
  export let selected: NodeViewProps["selected"];
  $$restProps; // prevent svelte unused props warning

  $: attrs = node.attrs as Attrs;
  $: ({ src, align, type } = attrs);
  $: alignment = CSS_ALIGNMENT[align];
</script>

<NodeViewWrapper {editor} class="flex {alignment} not-prose group relative my-2 rounded">
  {#if isEditable}
    <GutterMenu on:delete-block={deleteNode} />
  {/if}

  {#if src}
    <!-- set sizing using aspect ratio to prevent layout shift (between loading and loaded content) -->
    <div
      class="in-out-shadow flex basis-full items-center gap-1.5 rounded-md bg-black/2 px-2 py-2.5 after:rounded-md sm:basis-1/2 dark:bg-white/3"
      class:ring-2={selected && isEditable}
      class:cursor-pointer={isEditable}
    >
      <OVIcon
        icon={["riv", "rev"].includes(type) ? Rive : Attachment}
        size="size-6"
        class="not-prose m-1.5 text-gray-400"
      />
      <div class="flex flex-col">
        <div class="flex items-center gap-1.5">
          <span class="text-sm font-normal text-gray-500 md:text-[13px] dark:text-gray-300"
            >{attrs.fileName}</span
          >
        </div>
        <div class="ml-[1px] flex items-center gap-1.5 text-gray-400">
          <span class="text-xs font-normal">{getSizeHuman(attrs.fileSize)}</span>
        </div>
      </div>
      <a href={src} download class="ml-auto mr-2">
        <IconButton icon={Download} variant="tertiary" a11yLabel="Download {attrs.fileName}" />
      </a>
    </div>
  {/if}
</NodeViewWrapper>
